module.exports = __webpack_public_path__ + "static/media/show1.0c191c46.jpg";